import { Divider } from "antd";
import { styled } from "styled-components";
import { IDashboard, IPageableResponse } from "@dataone/lib";
import { PlusOutlined } from "@ant-design/icons";
interface DashboardPagesProps {
  selectedDashboard: { index: number; id: string; name: string };
  selectedPage: { index: number; id: string };
  setSelectedPage: React.Dispatch<{ index: number; id: string; name: string }>;
  isLoading: boolean;
  dashboards: IPageableResponse<Required<IDashboard>> | undefined;
  setNewPageButtonClicked: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedDashboard: React.Dispatch<{
    index: number;
    id: string;
    name: string;
  }>;
}

const DashboardPages = ({
  selectedDashboard,
  selectedPage,
  setSelectedPage,
  isLoading,
  dashboards,
  setNewPageButtonClicked,
  setSelectedDashboard,
}: DashboardPagesProps) => {
  const handlePageSelected = (index: number, id: string, name: string) => {
    setSelectedDashboard({
      index: selectedDashboard.index,
      id: selectedDashboard.id,
      name: selectedDashboard.name,
    });
    setSelectedPage({ index, id, name });
  };
  const handleAddPage = () => {
    setNewPageButtonClicked(true);
  };
  return (
    <StyledDashboardPages>
      {!isLoading &&
        dashboards?.content[selectedDashboard.index]?.pages.map(
          (element, index) => {
            return (
              <div key={index}>
                <h3
                  className={`page-title${
                    element.id === selectedPage.id ? " active-page" : ""
                  }`}
                  onClick={() =>
                    handlePageSelected(index, element.id!, element.name!)
                  }
                >
                  {element.name}
                </h3>
              </div>
            );
          }
        )}
      <NewPageButton onClick={handleAddPage}>
        <span>Add New Page</span>
        <PlusOutlined />
      </NewPageButton>
    </StyledDashboardPages>
  );
};

export default DashboardPages;

const NewPageButton = styled.div`
  background: #eff1fd;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  gap: 10px;
  cursor: pointer;
  height: 32px;
  margin: 10px 0px;
  font-size: 13px;
  &:hover {
    background: #4974f6;
    color: #fff;
  }
`;
const StyledDashboardPages = styled.div`
  // width: 200px;
  border-radius: 10px;
  // box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25) inset,
  //   0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  // padding: 20px 16px;
  // margin-top: 135px;
  .page-title {
    font-size: 12px;
    font-weight: 500;
    letter-spacing: -0.24px;
    padding: 9px 16px;
    margin: 10px 0px 10px 0px;
    border-radius: 10px;
    background: var(--black-100, #fff);
  }
  .active-page {
    border-radius: 10px;
    background: #4974f6;
    box-shadow: none;
    color: #fff;
  }
  .page-title:hover {
    border-radius: 10px;
    background: #4974f6;
    color: #fff;
  }
  .ant-divider-horizontal {
    margin: 0px;
  }
  .grid-selection-page {
    position: absolute;
    left: 800px;
    top: 2px;
    font-size: 30px;
    width: max-content;
  }
`;
